import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import AppLayout from '../../component/appLayout';
import { getProfileSettingData, updateEmailData } from '../../services/settingServices';
import {
  Details,
  Form,
  FormBlock,
  Group,
  InputValue,
  Label,
  PersonalText,
  MainForm,
  PersonalHeader,
  Header
} from './styles';
import ButtonV2 from '../../component/button/buttonV2';
import { captureException } from '../../services/logService';
import { useMobileDevice } from '../../global/useMobile';
import ResponsiveHeader from '../../component/responsiveHeader/header';
import BottomSubNavigation from '../../component/bottomNavigation/subNavigation';
import { BUTTON_TYPE } from '../../global/constants';
import { rootStore } from '../../mobx/rootStore';
import { observer } from 'mobx-react-lite';

const Email: React.FC = () => {
  // States
  const [loading, setLoading] = useState(false);
  //Mobx store variables
  const { settingStore } = rootStore;
  const { profileData } = settingStore;
  // Other variables
  const dispatch = useDispatch();
  const isMobile = useMobileDevice();
  const [password, setPassword] = useState('');

  // Loads profile settings data from the server
  const loadData = useCallback(async () => {
    await dispatch(getProfileSettingData());
  }, [dispatch]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  // Handles form submission and updates email
  const onClicksave = useCallback(
    async (e: React.SyntheticEvent) => {
      try {
        e.preventDefault();
        setLoading(true);
        const payload = { email: profileData?.email, password };
        const result = await dispatch(updateEmailData(payload));
        if (result) {
          rootStore.settingStore.updateProfileData('email', '');
          loadData();
        }
      } catch (error) {
        captureException(error);
        console.log('error', error);
        setLoading(false);
      } finally {
        setLoading(false);
      }
    },
    [dispatch, loadData, password, profileData?.email]
  );

  return (
    <>
      <AppLayout>
        <Group onSubmit={onClicksave} isMiddleContainer={true}>
          {!isMobile ? (
            <PersonalHeader>
              <Header>
                <PersonalText>Change your Email</PersonalText>
              </Header>
            </PersonalHeader>
          ) : (
            <ResponsiveHeader Title='Change your Email' />
          )}
          <Details>
            <MainForm>
              <FormBlock>
                <Form>
                  <Label>Email</Label>
                  <InputValue
                    type='email'
                    value={profileData?.email}
                    onChange={(e) => rootStore.settingStore.updateProfileData('email', e.target.value)}
                  />
                </Form>
                <Form>
                  <Label>Password</Label>
                  <InputValue type='password' value={password} onChange={(e) => setPassword(e.target.value)} />
                </Form>
              </FormBlock>
              <ButtonV2
                title='Change Email'
                variant={BUTTON_TYPE.PRIMARY}
                buttonType='submit'
                isLoading={loading}
                disabled={loading}
              />
            </MainForm>
          </Details>
        </Group>
      </AppLayout>
      <BottomSubNavigation />
    </>
  );
};
export default observer(Email);
